"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9458],{

/***/ 17919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _util_classNames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34855);
/* harmony import */ var _util_is__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53367);
/* harmony import */ var _ConfigProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40360);
/* harmony import */ var _util_hooks_useMergeProps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92833);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82674);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};






var defaultProps = {
    span: 24,
};
function getFlexString(flex) {
    if (typeof flex === 'string' && /\d+[px|%|em|rem|]{1}/.test(flex)) {
        return "0 0 " + flex;
    }
    return flex;
}
function Col(baseProps, ref) {
    var _a;
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_ConfigProvider__WEBPACK_IMPORTED_MODULE_1__/* .ConfigContext */ .E_), getPrefixCls = _b.getPrefixCls, componentConfig = _b.componentConfig, rtl = _b.rtl;
    var props = (0,_util_hooks_useMergeProps__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig['Grid.Col']);
    var _c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context__WEBPACK_IMPORTED_MODULE_3__/* .RowContext */ .g6), gutter = _c.gutter, div = _c.div;
    var className = props.className, style = props.style, children = props.children, span = props.span, offset = props.offset, order = props.order, pull = props.pull, push = props.push, xs = props.xs, sm = props.sm, md = props.md, lg = props.lg, xl = props.xl, xxl = props.xxl, xxxl = props.xxxl, flex = props.flex, rest = __rest(props, ["className", "style", "children", "span", "offset", "order", "pull", "push", "xs", "sm", "md", "lg", "xl", "xxl", "xxxl", "flex"]);
    function adaptationGrid(prefixCls, mergeClassName) {
        var screenList = { xs: xs, sm: sm, md: md, lg: lg, xl: xl, xxl: xxl, xxxl: xxxl };
        Object.keys(screenList).forEach(function (screen) {
            var screenValue = screenList[screen];
            if ((0,_util_is__WEBPACK_IMPORTED_MODULE_4__/* .isNumber */ .hj)(screenValue)) {
                if (screenValue >= 0) {
                    mergeClassName[prefixCls + "-" + screen + "-" + screenValue] = true;
                }
            }
            else if ((0,_util_is__WEBPACK_IMPORTED_MODULE_4__/* .isObject */ .Kn)(screenValue)) {
                mergeClassName[prefixCls + "-" + screen + "-" + screenValue.span] = screenValue.span;
                mergeClassName[prefixCls + "-" + screen + "-offset-" + screenValue.offset] = screenValue.offset;
                mergeClassName[prefixCls + "-" + screen + "-order-" + screenValue.order] = screenValue.order;
                mergeClassName[prefixCls + "-" + screen + "-pull-" + screenValue.pull] = screenValue.pull;
                mergeClassName[prefixCls + "-" + screen + "-push-" + screenValue.push] = screenValue.push;
            }
        });
        return mergeClassName;
    }
    var prefixCls = getPrefixCls('col');
    var mergeClassName = (_a = {},
        _a["" + prefixCls] = !div,
        _a[prefixCls + "-order-" + order] = order,
        _a[prefixCls + "-" + span] = !div && !xs && !sm && !md && !lg && !xl && !xxl && !xxxl,
        _a[prefixCls + "-offset-" + offset] = offset,
        _a[prefixCls + "-pull-" + pull] = pull,
        _a[prefixCls + "-push-" + push] = push,
        _a[prefixCls + "-rtl"] = rtl,
        _a);
    mergeClassName = adaptationGrid(prefixCls, mergeClassName);
    var classNames = (0,_util_classNames__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(flex ? prefixCls : mergeClassName, className);
    var paddingStyle = {};
    if (Array.isArray(gutter) && !div) {
        var paddingHorizontal = (gutter[0] && gutter[0] / 2) || 0;
        var paddingVertical = (gutter[1] && gutter[1] / 2) || 0;
        if (paddingHorizontal) {
            paddingStyle.paddingLeft = paddingHorizontal;
            paddingStyle.paddingRight = paddingHorizontal;
        }
        if (paddingVertical) {
            paddingStyle.paddingTop = paddingVertical;
            paddingStyle.paddingBottom = paddingVertical;
        }
    }
    var flexStyle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () { return (getFlexString(flex) ? { flex: getFlexString(flex) } : {}); }, [flex]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", __assign({ ref: ref }, rest, { style: __assign(__assign(__assign({}, style), paddingStyle), flexStyle), className: classNames }), children));
}
var ColComponent = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Col);
ColComponent.displayName = 'Col';
/* harmony default export */ __webpack_exports__["Z"] = (ColComponent);


/***/ }),

/***/ 82674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lx": function() { return /* binding */ GridDataCollectorContext; },
/* harmony export */   "_p": function() { return /* binding */ GridContext; },
/* harmony export */   "g6": function() { return /* binding */ RowContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var RowContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var GridContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var GridDataCollectorContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});


/***/ }),

/***/ 79458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_Grid; }
});

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Grid/col.js
var col = __webpack_require__(17919);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Grid/row.js
var row = __webpack_require__(82713);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var _util_classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 3 modules
var ConfigProvider = __webpack_require__(40360);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/responsiveObserve.js
var responsiveObserve = __webpack_require__(6901);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Grid/hooks/useResponsiveState.js
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};



function isResponsiveValue(val) {
    return (0,is/* isObject */.Kn)(val);
}
var useResponsiveState = function (val, defaultValue, fallbackToXs) {
    if (fallbackToXs === void 0) { fallbackToXs = false; }
    var token = (0,react.useRef)();
    var _a = __read((0,react.useState)({
        xs: true,
        sm: true,
        md: true,
        lg: true,
        xl: true,
        xxl: true,
        xxxl: true,
    }), 2), screens = _a[0], setScreens = _a[1];
    (0,react.useEffect)(function () {
        token.current = responsiveObserve/* default.subscribe */.ZP.subscribe(function (screens) {
            if (isResponsiveValue(val)) {
                setScreens(screens);
            }
        });
        return function () {
            responsiveObserve/* default.unsubscribe */.ZP.unsubscribe(token.current);
        };
    }, []);
    var result = (0,react.useMemo)(function () {
        var res = defaultValue;
        if (isResponsiveValue(val)) {
            for (var i = 0; i < responsiveObserve/* responsiveArray.length */.c4.length; i++) {
                var breakpoint = responsiveObserve/* responsiveArray */.c4[i];
                if ((screens[breakpoint] || (breakpoint === 'xs' && fallbackToXs)) &&
                    val[breakpoint] !== undefined) {
                    res = val[breakpoint];
                    break;
                }
            }
        }
        else {
            res = val;
        }
        return res;
    }, [screens, val, defaultValue, fallbackToXs]);
    return result;
};

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Grid/context.js
var context = __webpack_require__(82674);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Grid/utils.js
function resolveItemData(cols, _a) {
    var span = _a.span, offset = _a.offset, suffix = _a.suffix;
    var originSpan = span !== null && span !== void 0 ? span : 1;
    var originOffset = offset !== null && offset !== void 0 ? offset : 0;
    var minOffset = Math.min(originOffset, cols);
    var minSpan = Math.min(minOffset > 0 ? originSpan + originOffset : originSpan, cols);
    return {
        span: minSpan,
        offset: minOffset,
        suffix: suffix,
    };
}
function setItemVisible(_a) {
    var cols = _a.cols, collapsed = _a.collapsed, collapsedRows = _a.collapsedRows, itemDataList = _a.itemDataList;
    var overflow = false;
    var displayIndexList = [];
    function isOverflow(span) {
        return Math.ceil(span / cols) > collapsedRows;
    }
    if (collapsed) {
        var spanSum = 0;
        for (var i = 0; i < itemDataList.length; i++) {
            if (itemDataList[i].suffix) {
                spanSum += itemDataList[i].span;
                displayIndexList.push(i);
            }
        }
        if (!isOverflow(spanSum)) {
            var current = 0;
            while (current < itemDataList.length) {
                var item = itemDataList[current];
                if (!item.suffix) {
                    spanSum += item.span;
                    if (isOverflow(spanSum)) {
                        break;
                    }
                    displayIndexList.push(current);
                }
                current++;
            }
        }
        overflow = itemDataList.some(function (item, index) { return !item.suffix && !displayIndexList.includes(index); });
    }
    else {
        displayIndexList = itemDataList.map(function (_, index) { return index; });
    }
    return {
        overflow: overflow,
        displayIndexList: displayIndexList,
    };
}

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Grid/grid.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var grid_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (undefined && undefined.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};








var defaultProps = {
    collapsed: false,
    collapsedRows: 1,
    cols: 24,
    colGap: 0,
    rowGap: 0,
};
function Grid(baseProps, ref) {
    var _a;
    var _b = grid_read((0,react.useState)(new Map()), 2), itemDataMap = _b[0], setItemDataMap = _b[1];
    var _c = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _c.getPrefixCls, componentConfig = _c.componentConfig, rtl = _c.rtl;
    var props = (0,useMergeProps/* default */.Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.Grid);
    var children = props.children, className = props.className, style = props.style, propCols = props.cols, propColGap = props.colGap, propRowGap = props.rowGap, collapsed = props.collapsed, collapsedRows = props.collapsedRows;
    var cols = useResponsiveState(propCols, 24);
    var colGap = useResponsiveState(propColGap, 0);
    var rowGap = useResponsiveState(propRowGap, 0);
    var gridStyle = {
        gap: rowGap + "px " + colGap + "px",
        gridTemplateColumns: "repeat(" + cols + ", minmax(0px, 1fr))",
    };
    var prefixCls = getPrefixCls('grid');
    var mergeClassName = (_a = {},
        _a["" + prefixCls] = true,
        _a[prefixCls + "-rtl"] = rtl,
        _a);
    var classNames = (0,_util_classNames/* default */.Z)(mergeClassName, className);
    var getItemDataList = function () {
        var e_1, _a;
        var list = [];
        try {
            for (var _b = __values(itemDataMap.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = grid_read(_c.value, 2), index = _d[0], itemData = _d[1];
                list[index] = itemData;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return list;
    };
    var itemDataList = getItemDataList();
    var displayInfo = setItemVisible({
        cols: cols,
        collapsed: collapsed,
        collapsedRows: collapsedRows,
        itemDataList: itemDataList,
    });
    return (react.createElement("div", { ref: ref, className: classNames, style: __assign(__assign({}, gridStyle), style) },
        react.createElement(context/* GridDataCollectorContext.Provider */.Lx.Provider, { value: {
                collectItemData: function (index, itemData) {
                    itemDataMap.set(index, itemData);
                    setItemDataMap(new Map(__spreadArray([], grid_read(itemDataMap), false)));
                },
                removeItemData: function (index) {
                    itemDataMap.delete(index);
                    setItemDataMap(new Map(__spreadArray([], grid_read(itemDataMap), false)));
                },
            } },
            react.createElement(context/* GridContext.Provider */._p.Provider, { value: {
                    cols: cols,
                    colGap: colGap,
                    collapsed: collapsed,
                    overflow: displayInfo.overflow,
                    displayIndexList: displayInfo.displayIndexList,
                } }, react.Children.map(children, function (child, index) {
                if (child) {
                    var childProps = __assign({ __index__: index }, child.props);
                    return react.cloneElement(child, childProps);
                }
                return null;
            }).filter(function (child) { return get_default()(child, 'type.__ARCO_GRID_ITEM__'); })))));
}
var GridComponent = (0,react.forwardRef)(Grid);
GridComponent.displayName = 'Grid';
/* harmony default export */ var grid = (GridComponent);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Grid/grid-item.js
var grid_item_assign = (undefined && undefined.__assign) || function () {
    grid_item_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return grid_item_assign.apply(this, arguments);
};








var grid_item_defaultProps = {
    suffix: false,
    offset: 0,
    span: 1,
};
function GridItem(baseProps, ref) {
    var _a;
    var _b = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _b.getPrefixCls, componentConfig = _b.componentConfig, rtl = _b.rtl;
    var props = (0,useMergeProps/* default */.Z)(baseProps, grid_item_defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig['Grid.GridItem']);
    var children = props.children, className = props.className, style = props.style, propOffset = props.offset, propSpan = props.span, computedIndex = props.__index__;
    var gridContext = (0,react.useContext)(context/* GridContext */._p);
    var _c = (0,react.useContext)(context/* GridDataCollectorContext */.Lx), collectItemData = _c.collectItemData, removeItemData = _c.removeItemData;
    var colGap = gridContext.colGap, cols = gridContext.cols, displayIndexList = gridContext.displayIndexList, overflow = gridContext.overflow;
    var offset = useResponsiveState(propOffset, 0);
    var span = useResponsiveState(propSpan, 1);
    var prefixCls = getPrefixCls('grid-item');
    var visible = displayIndexList === null || displayIndexList === void 0 ? void 0 : displayIndexList.includes(computedIndex);
    var mergeClassName = (_a = {},
        _a["" + prefixCls] = true,
        _a[prefixCls + "-rtl"] = rtl,
        _a);
    var classNames = (0,_util_classNames/* default */.Z)(mergeClassName, className);
    var itemData = (0,react.useMemo)(function () {
        return resolveItemData(gridContext.cols, {
            suffix: !!props.suffix,
            span: span,
            offset: offset,
        });
    }, [gridContext.cols, props.suffix, span, offset]);
    (0,react.useEffect)(function () {
        collectItemData(computedIndex, itemData);
        return function () {
            removeItemData(computedIndex);
        };
    }, [computedIndex, itemData]);
    var offsetStyle = (0,react.useMemo)(function () {
        var offset = itemData.offset, span = itemData.span;
        if (offset > 0) {
            var oneSpan = "(100% - " + colGap * (span - 1) + "px) / " + span;
            return {
                marginLeft: "calc((" + oneSpan + " * " + offset + ") + " + colGap * offset + "px)",
            };
        }
        return {};
    }, [itemData, colGap]);
    var columnStart = (0,react.useMemo)(function () {
        var suffix = itemData.suffix, span = itemData.span;
        if (suffix) {
            return "" + (cols - span + 1);
        }
        return "span " + span;
    }, [itemData, cols]);
    var visibleStyle = !visible || span === 0 ? { display: 'none' } : {};
    var gridItemStyle = grid_item_assign(grid_item_assign({ gridColumn: columnStart + " / span " + span }, offsetStyle), visibleStyle);
    return (react.createElement("div", { ref: ref, className: classNames, style: grid_item_assign(grid_item_assign({}, gridItemStyle), style) }, (0,is/* isFunction */.mf)(children)
        ? children({ overflow: overflow })
        : react.Children.map(children, function (child) {
            if (child &&
                gridContext.collapsed &&
                react.isValidElement(child) &&
                !(0,is/* isString */.HD)(child.type)) {
                // 排除原生 dom 标签，避免 overflow 属性透传到 dom 标签上
                return react.cloneElement(child, grid_item_assign({ overflow: overflow }, child.props));
            }
            return child;
        })));
}
var ForwardRefGridItem = (0,react.forwardRef)(GridItem);
var GridItemComponent = ForwardRefGridItem;
GridItemComponent.displayName = 'GridItem';
GridItemComponent.__ARCO_GRID_ITEM__ = true;
/* harmony default export */ var grid_item = (GridItemComponent);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Grid/index.js




var Grid_Grid = grid;
Grid_Grid.Col = col/* default */.Z;
Grid_Grid.Row = row/* default */.Z;
Grid_Grid.GridItem = grid_item;
/* harmony default export */ var es_Grid = (Grid_Grid);


/***/ }),

/***/ 82713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _util_classNames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34855);
/* harmony import */ var _util_omit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50049);
/* harmony import */ var _ConfigProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40360);
/* harmony import */ var _util_responsiveObserve__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6901);
/* harmony import */ var _util_hooks_useMergeProps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92833);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82674);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};







var defaultProps = {
    gutter: 0,
    align: 'start',
    justify: 'start',
};
function Row(baseProps, ref) {
    var _a;
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_ConfigProvider__WEBPACK_IMPORTED_MODULE_1__/* .ConfigContext */ .E_), getPrefixCls = _b.getPrefixCls, componentConfig = _b.componentConfig, rtl = _b.rtl;
    var props = (0,_util_hooks_useMergeProps__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig['Grid.Row']);
    var className = props.className, style = props.style, children = props.children, div = props.div, align = props.align, justify = props.justify, gutter = props.gutter, rest = __rest(props, ["className", "style", "children", "div", "align", "justify", "gutter"]);
    var _c = __read((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        xs: true,
        sm: true,
        md: true,
        lg: true,
        xl: true,
        xxl: true,
        xxxl: true,
    }), 2), screens = _c[0], setScreens = _c[1];
    var token = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        token.current = _util_responsiveObserve__WEBPACK_IMPORTED_MODULE_3__/* ["default"].subscribe */ .ZP.subscribe(function (screens) {
            // Responsive Gutter
            if ((!Array.isArray(gutter) && typeof gutter === 'object') ||
                (Array.isArray(gutter) && (typeof gutter[0] === 'object' || typeof gutter[1] === 'object'))) {
                setScreens(screens);
            }
        });
        return function () {
            _util_responsiveObserve__WEBPACK_IMPORTED_MODULE_3__/* ["default"].unsubscribe */ .ZP.unsubscribe(token.current);
        };
    }, []);
    function getGutter(gutter) {
        var result = 0;
        if (typeof gutter === 'object') {
            for (var i = 0; i < _util_responsiveObserve__WEBPACK_IMPORTED_MODULE_3__/* .responsiveArray.length */ .c4.length; i++) {
                var breakpoint = _util_responsiveObserve__WEBPACK_IMPORTED_MODULE_3__/* .responsiveArray */ .c4[i];
                if (screens[breakpoint] && gutter[breakpoint] !== undefined) {
                    result = gutter[breakpoint];
                    break;
                }
            }
        }
        else {
            result = gutter;
        }
        return result;
    }
    var prefixCls = getPrefixCls('row');
    var classNames = (0,_util_classNames__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((_a = {},
        _a["" + prefixCls] = !div,
        _a[prefixCls + "-align-" + align] = align,
        _a[prefixCls + "-justify-" + justify] = justify,
        _a[prefixCls + "-rtl"] = rtl,
        _a), className);
    var marginStyle = {};
    var gutterHorizontal = getGutter(Array.isArray(gutter) ? gutter[0] : gutter);
    var gutterVertical = getGutter(Array.isArray(gutter) ? gutter[1] : 0);
    if ((gutterHorizontal || gutterVertical) && !div) {
        var marginHorizontal = -gutterHorizontal / 2;
        var marginVertical = -gutterVertical / 2;
        if (marginHorizontal) {
            marginStyle.marginLeft = marginHorizontal;
            marginStyle.marginRight = marginHorizontal;
        }
        if (marginVertical) {
            marginStyle.marginTop = marginVertical;
            marginStyle.marginBottom = marginVertical;
        }
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", __assign({ ref: ref }, (0,_util_omit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(rest, ['gutter']), { style: __assign(__assign({}, style), marginStyle), className: classNames }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_context__WEBPACK_IMPORTED_MODULE_6__/* .RowContext.Provider */ .g6.Provider, { value: { gutter: [gutterHorizontal, gutterVertical], div: div } }, children)));
}
var RowComponent = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Row);
RowComponent.displayName = 'Row';
/* harmony default export */ __webpack_exports__["Z"] = (RowComponent);


/***/ })

}]);